import { create } from 'zustand';

type DrawerPhase = 'running' | 'completed' | 'error';

interface HuntDrawerState {
  isOpen: boolean;
  phase: DrawerPhase;
  huntUuid: string | null;

  open: (huntUuid: string, phase?: DrawerPhase) => void;
  close: () => void;
  setPhase: (phase: DrawerPhase) => void;
  setHuntUuid: (uuid: string | null) => void;
  reset: () => void;
}

export const useAutoDrawerStore = create<HuntDrawerState>(set => ({
  isOpen: false,
  phase: 'running',
  huntUuid: null,

  open: (huntUuid, phase = 'running') => set({ isOpen: true, huntUuid, phase }),
  close: () => set({ isOpen: false }),
  setPhase: phase => set({ phase }),
  setHuntUuid: uuid => set({ huntUuid: uuid }),
  reset: () =>
    set({
      isOpen: false,
      phase: 'running',
      huntUuid: null,
    }),
}));

export type { DrawerPhase };
